import { SxProps } from '@mui/system'

import { theme } from 'src/providers/ThemeProvider'

type NIGFieldStylesType = {
  NIGFullNumberhiddenField: SxProps
  wrapper: SxProps
  input: SxProps
  composeInput: SxProps
  separator: SxProps
}

export const NIGFieldStyles: NIGFieldStylesType = {
  NIGFullNumberhiddenField: {
    visibility: 'hidden',
    height: 0
  },

  wrapper: {
    '&[data-disabled="false"] > span': {
      color: theme.corporate.errorColor
    }
  },

  composeInput: {
    width: '100%',
    border: `1px solid ${theme.colors.gray17}`,
    borderRadius: '4px',
    height: 38,

    '.multiField[data-disabled="true"] &': {
      backgroundColor: theme.colors.gray04
    },

    '.multiField[data-disabled="false"] &:hover': {
      backgroundColor: theme.colors.blue08
    },

    '.multiField[data-error="true"] &': {
      borderColor: theme.colors.red01
    },

    '.multiField[data-active="true"] &': {
      borderColor: theme.corporate.primaryColor,
      backgroundColor: theme.colors.white01
    },

    '.multiField[data-active="true"] &:hover': {
      backgroundColor: theme.colors.white01
    },

    '.multiField[data-disabled="false"][data-active="true"] & .MuiInputBase-root:hover': {
      backgroundColor: theme.colors.white01
    },

    '& input:-webkit-autofill': {
      backgroundColor: 'transparent !important'
    }
  },

  separator: {
    flex: '0 0 1px',
    height: 18,
    margin: '1px',
    backgroundColor: theme.colors.gray17,
    alignSelf: 'center',

    '.multiField[data-error="true"] &': {
      backgroundColor: theme.colors.red01
    },

    '.multiField[data-active="true"] &': {
      backgroundColor: theme.corporate.primaryColor
    }
  },

  input: {
    flex: '1 1 auto',

    '& .MuiInputBase-root': {
      height: 36,
      borderWidth: '0 !important'
    },

    '& .MuiInputBase-input': {
      textAlign: 'center'
    }
  }
}
